import base from './base.repository';

export default {
    ...base,
    getKits() {
        this.get('kits');
        return this;
    },
    getKit(id) {
        this.get(`kits/${id}`);
        return this;
    },
    saveKit(payload) {
        this.post('kits', payload);
        return this;
    },
    updateKit(payload, id) {
        this.put(`kits/${id}`, payload);
        return this;
    },
    deleteKit(id) {
        this.delete(`kits/${id}`);
        return this;
    },
    getAvailableItems() {
        this.get('kits/available-items');
        return this;
    }
};

